import { ref } from 'vue'

const show = ref(false)
const message = ref('')
const type = ref<'success' | 'error' | 'warning' | 'info'>('success')
const timeout = ref(3000)

export function useToast() {
    const trigger = (msg: string, t: 'success' | 'error' | 'warning' | 'info' = 'success', duration = 3000) => {
        message.value = msg
        type.value = t
        show.value = true
        timeout.value = duration

        setTimeout(() => {
            // Check if it's the same message (simple concurrency handling)
            if (show.value && message.value === msg) {
                show.value = false
            }
        }, duration)
    }

    return {
        show,
        message,
        type,
        success: (msg: string) => trigger(msg, 'success'),
        error: (msg: string) => trigger(msg, 'error'),
        warning: (msg: string) => trigger(msg, 'warning'),
        info: (msg: string) => trigger(msg, 'info'),
    }
}
